import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBuilding(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.166 15.625h8.964m-8.964 0V5.545c0-1.337 1.147-2.42 2.561-2.42H9.57c1.414 0 2.56 1.083 2.56 2.42v1.007m-8.963 9.073H1.46m10.67 0V6.552m0 9.073h5.123M12.13 6.552h2.56c1.415 0 2.562 1.084 2.562 2.42v6.653m0 0h1.707M8.715 7.157H6.581m0 3.226h2.134"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBuilding);
export default ForwardRef;
